import {usePaddle} from "@/components/pricing/use-paddle";
import {useEffect, useState} from "react";
import * as Sentry from "@sentry/nextjs";
import {usePricingPlans} from "@/components/pricing/pricing-plans";
import {ccyPrice} from "@/components/pricing/price-utils";

//  https://developer.paddle.com/build/checkout/build-pricing-page#pricing-preview
export function useDynamicPricingPlans() {
    const pricingPlans = usePricingPlans();
    const [loadingPrices, setLoadingPrices] = useState(true);
    const {loading: paddleLoading, paddle, error: paddleError} = usePaddle();
    const [newPlans, setNewPlans] = useState(pricingPlans);

    useEffect(() => {
        if (paddleLoading) {
            return;
        }
        if (paddleError) {
            setLoadingPrices(false);
            return;
        }
        const items = pricingPlans.flatMap(({plan, planPlus}) => (
            [plan.monthlyPriceId, plan.annualPriceId, planPlus.monthlyPriceId, planPlus.annualPriceId]
                .map(priceId => ({priceId, quantity: 1}))));
        paddle!.PricePreview({items})
            .then((result) => {
                const newPlans = pricingPlans.map(p => ({...p}));
                const items = result.data.details.lineItems;
                for (const item of items) {
                    const { price: { id: priceId, unitPrice: { amount, currencyCode } } } = item;
                    const currencyPrice = ccyPrice(Number(amount) / 100, currencyCode);;
                    for (const {plan, planPlus} of newPlans) {
                        if (priceId === plan.monthlyPriceId) {
                            plan.monthlyPrice = currencyPrice;
                        } else if (priceId === plan.annualPriceId) {
                            plan.annualPrice = currencyPrice;
                        } else if (priceId === planPlus.monthlyPriceId) {
                            planPlus.monthlyPrice = currencyPrice;
                        } else if (priceId === planPlus.annualPriceId) {
                            planPlus.annualPrice = currencyPrice;
                        }
                    }
                }
                setNewPlans(newPlans);
            })
            .catch((error) => {
                Sentry.captureException(error);
                console.error(error);
            })
            .finally(() => {
                setLoadingPrices(false);
            });
    }, [paddle, paddleError, paddleLoading, pricingPlans]);

    return {
        loadingPrices,
        error: paddleError,
        plans: newPlans
    }
}
